module.exports = __webpack_public_path__ + "static/media/Vegetarian_.79a1f5e0.png";